import authInterceptor from "../../AuthInterceptor";

export const RankingAlgorithmSettingsAPI = {
  getRankingWeights: (config = {}) =>
    authInterceptor
      .get(`ranking-api/playground/ranking_weights`, config)
      .then((response) => response.data)
      .catch((error) => error.response),
  applyRankingWeights: (bodyData = {}) =>
    authInterceptor
      .post(`ranking-api/playground/apply_ranking_weights`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),
  restoreDefaultWeights: (bodyData = {}) =>
    authInterceptor
      .post(`ranking-api/playground/reset_ranking_weights`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),
  simulateRanking: (bodyData = {}) =>
    authInterceptor
      .post(`ranking-api/playground/simulate_ranking_weights`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),
  reRunRanking: (config = {}) =>
    authInterceptor
      .get(`ranking-api/admin/re-run-ranking/`, config)
      .then((response) => response.data)
      .catch((error) => error.response),
};
